let card = null
let card_list = null
export default {
    card,
    card_list,
}